import lng from '../Utils/languge'

const StringLocalizer = (en: string, ar: string) => {
    if(lng.getLang() === lng.Languge.AR){
        return ar
    }
    return en
}

export default StringLocalizer;